import { unfilledQuestions, validateButtons, questionsResponseNotChangedSwitches }
    from "./questions";

export default function () {
    addEventListeners();
    updateValidateButtonDisabledStatus();
}

// binds so we know when to revalidate

function addEventListeners() {
    $("textarea").keyup(updateValidateButtonDisabledStatus);
}

// pulling it altogether

function updateButtonStatus(button, shouldBeDisabled) {
    if (shouldBeDisabled) {
        button.setAttribute("disabled", "disabled");
    }
    else {
        button.removeAttribute("disabled");
    }
}

export function updateValidateButtonDisabledStatus() {
    const shouldBeDisabled = !!unfilledQuestions().length;
    validateButtons().forEach(button => updateButtonStatus(button, shouldBeDisabled));
}

